"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCertGlobe = function SvgCertGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#C6A378",
    strokeWidth: 1.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.651 0c2.507 0 11.396 4.718 11.396 22.734 0 18.016-8.66 22.95-11.396 22.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.79 0c-2.506 0-11.395 4.718-11.395 22.734 0 18.016 8.661 22.95 11.396 22.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.419 10.028c2.51 2.037 8.208 4.457 19.55 4.457 10.65 0 16.405-2.08 19.194-4.02M4.558 36.77c2.362-2.038 7.726-4.458 18.4-4.458 10.024 0 15.44 2.08 18.066 4.021M0 23.956h45.582M22.22 0v45.683"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.791,
    cy: 22.842,
    rx: 22.791,
    ry: 22.842
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCertGlobe);
var _default = exports["default"] = Memo;